import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BranchTaxDefaultsEditService {

  constructor(private http: HttpClient) { }

  savePivotedData(
    baseUrl: string,
    returnClobSettingsObj: any,
    defaultsChangeDetails: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/saveJsonAsPivotObject?action_code=brk8nt`;

    const clobSettings = {
      sso_id: returnClobSettingsObj.sso_id,
      scenario: returnClobSettingsObj.scenario
    };

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(defaultsChangeDetails) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);

    if (!params.tax_year) {
      params.tax_year = filterParams.tax_year || globalService?.globalParams?.tax_year || '';
    }
    if (!params.scenario) {
      params.scenario = filterParams.scenario || globalService?.globalParams?.scenario || '';
    }
    if (!params.jcd_key) {
      params.jcd_key = filterParams.jcd_key || globalService?.globalParams?.jcd_key || 250;
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, value.toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
